import { forwardRef, useState } from "react";
import styled from "styled-components";
import { themeColor, themeFontSize } from "../../theme";
import { HelperText } from "../helperText/HelperText";

export const TextArea = forwardRef(
  (
    {
      label,
      setValue,
      isError = false,
      errorText,
      id,
      value,
      maxLength,
      minLength,
      minHeight,
      height,
      labelWeight,
      centerText = false,
      ...rest
    },
    ref
  ) => {
    const [hide, setHide] = useState(false);
    const onChangeHandler = (el) => {
      setValue?.(el.target.value);
    };

    const showLimitCharacter = () => {
      if (!value) return null;

      if (maxLength > 0 && minLength === 0) {
        return (
          <HelperText size="regular" sizeMobile="small" color="placeholder">
            {value.length} / {maxLength}
          </HelperText>
        );
      }

      if (value.length < minLength) {
        return (
          <HelperText size="regular" sizeMobile="small" color="placeholder">
            {minLength - value.length} more required
          </HelperText>
        );
      }

      return (
        <HelperText size="regular" sizeMobile="small" color="placeholder">
          {value.length} / {maxLength}
        </HelperText>
      );
    };
    return (
      <TextAreaWrapper>
        {label && (
          <HelperText htmlFor={id} className="pre-line" weight={labelWeight}>
            {label}
          </HelperText>
        )}
        <TextAreaContainer>
          <TextAreaStyled
            id={id}
            ref={ref}
            onChange={onChangeHandler}
            value={value}
            maxLength={maxLength}
            minLength={minLength}
            height={height}
            onFocus={() => setHide(true)}
            onBlur={() => setHide(false)}
            isError={isError}
            centerText={value ? centerText : false}
            {...rest}
          />
        </TextAreaContainer>
        {value && hide && maxLength ? (
          <ShowLimitCharacterContainer className="showLimit">
            {showLimitCharacter()}
          </ShowLimitCharacterContainer>
        ) : null}
        {isError ? (
          <HelperText color="pink" size="small">
            {errorText || ""}
          </HelperText>
        ) : null}
      </TextAreaWrapper>
    );
  }
);

const TextAreaWrapper = styled.div`
  width: 100%;
  display: grid;
  gap: 1rem;
  font-family: var(--font-secondary);

  & .pre-line {
    white-space: pre-line;
  }
`;

const TextAreaContainer = styled.div`
  width: 100%;
  position: relative;
`;

const TextAreaStyled = styled.textarea`
  width: 100%;
  min-height: ${({ height }) => height ?? "100px"};
  padding: 10px;
  font-size: ${themeFontSize("regular")};
  border-width: 2px;
  border-style: solid;
  border-color: ${({ isError }) =>
    isError ? themeColor("pink") : themeColor("lightBlue")};
  outline: none;
  font-family: var(--font-secondary);
  border-radius: 10px;
  resize: none;
  align-content: ${({ centerText }) => centerText ? "center" : "flex-start"} ;

  &::placeholder {
    color: ${themeColor("placeholder")};
    font-weight: 400;
  }

  #showLimit {
    display: none;
  }
`;
const ShowLimitCharacterContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`;
